import type { SxProps, Theme } from '@mui/material/styles';

export const groupRowsContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};
